import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthAmplifyService } from '../shared/service/auth-amplify.service';
import { LanguageService } from '../shared/service/language.service';

@Injectable({ providedIn: 'root' })
export class JwtInterceptor implements HttpInterceptor {
    constructor(private readonly authAmplifyService: AuthAmplifyService,
        private readonly _languageService: LanguageService
        ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {      
        if (request.url.startsWith(environment.apiEndPoint) || (request.url.startsWith(environment.proxyUrl))) {
           
            request = request.clone({
                setHeaders: {
                    'locale': `${this._languageService.getUserSelectedLanguage()??'en-GB'}`,
                    'user-role': 'Business_Portal',
                },
                withCredentials:true
            });
        }
        
        return next.handle(request);
    }    
}